var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"music-preview",class:{ 'playing' : _vm.playing },on:{"click":_vm.preview}},[_c('span',[_vm._v("Preview")]),_c('div',{staticClass:"icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }